import { statLeadersFragment } from "../Teams/team.fragments"

export const matchupPageEventInfoQuery = `
query($slug: ID, $year: Int, $statList: [String]) {
  event(slug:$slug) {
    id
    slugname
    startTime
    eventStatus
    description
    seasonSegment
    urlStreaming
    urlTicket
    week
    broadcaster
    league
    location
    venue
    gameStatus
    addToCalendarId
    year
    awayTeam {
      officialId
      location
      locationCode
      teamColor
      teamLogo: urlLogo  
      fullName
      teamWins
      teamWinsPost
      teamLosses
      teamLossesPost
      teamTies
      teamTiesPost
      csStatLeaders: statLeaders(statYear: $year, seasonSegment: champseries, statList: $statList) {
        ...StatLeadersFragment
      }
      statLeaders(statYear: $year, seasonSegment: regular, statList: $statList) {
        ...StatLeadersFragment
      }
    }
    homeTeam {
      officialId
      location
      locationCode
      teamColor
      teamLogo: urlLogo  
      fullName
      teamWins
      teamWinsPost
      teamLosses
      teamLossesPost
      teamTies
      teamTiesPost
      csStatLeaders: statLeaders(statYear: $year, seasonSegment: champseries, statList: $statList) {
        ...StatLeadersFragment
      }
      statLeaders(statYear: $year, seasonSegment: regular, statList: $statList) {
        ...StatLeadersFragment
      }
    }
    pregameWinProbabilities {
      awayTeamWinProbability
      homeTeamWinProbability
    }
    matchupInfo {
      matchupPreview
      keyMatchupText
      featuredImage
      articleLink
      recapLink
      keyMatchup {
        officialId
        profileUrl
        slug
        firstName
        lastName
        jerseyNum
        position
        teamId
        stats {
          gamesPlayed
          points
          onePointGoals
          assists
          shotPct
          causedTurnovers
          groundBalls
          shots
          faceoffPct
          faceoffs
          saa
          saves
          savePct
        }
      }
      previousMatchups {
        eventId
        week
        startTime
        homeTeam {
          officialId
          scores
          shotPct
          twoPointGoals
          turnovers
          faceoffPct
          savePct
        }
        awayTeam{
          officialId
          scores
          shotPct
          twoPointGoals
          turnovers
          faceoffPct
          savePct
        }
      }
    }
  }
}
${statLeadersFragment}
`

export const eventInProgressBySlug = `
query($slug: ID) {
  event(slug:$slug) {
    eventStatus
    visitorScore
    homeScore
    period
    clockTenths
    clockSeconds
    clockMinutes
  }
}
`

export const allFanResultsByEvent = `
query($eventId: Int!) {
  fanResults(eventId:$eventId) {
    teamId
    count
  }
}
`

export const eventInfoWithTeamAndPlayers = `
query($slug: ID) {
  event(slug: $slug) {
    id
    slugname
    externalId
    year
    startTime
    week
    venue
    description
    location
    gameNumber
    broadcaster
    eventStatus
    period
    homeScore
    homePeriodScores
    visitorScore
    visitorPeriodScores
    urlTicket
    league
    urlPreview
    seasonSegment
    urlStreaming
    addToCalendarId
    gameStatus
    awayTeam {
      ...teamInfo
    }
    homeTeam {
      ...teamInfo
    }
  }
  }

  fragment teamInfo on Team {
    officialId
    location
    locationCode
    fullName
    wins
    losses
    ties
    teamWins
    teamLosses
    teamTies
    conference
    stats(segment: event) {
      assists
      causedTurnovers
      clearAttempts
      clearPct
      clears
      faceoffPct
      faceoffs
      faceoffsLost
      faceoffsWon
      gamesPlayed
      goals
      goalsAgainst
      groundBalls
      manDownPct
      numPenalties
      onePointGoals
      pim
      powerPlayGoals
      powerPlayGoalsAgainst
      powerPlayGoalsAgainstPct
      rideAttempts
      saa
      savePct
      saves
      scores
      scoresAgainst
      shotClockExpirations
      shotPct
      shots
      shotsOnGoal
      shotsOnGoalPct
      timesManUp
      timesShortHanded
      turnovers
      twoPointGoalsAgainst
      twoPointShots
      twoPointShotsOnGoal
      twoPointGoals
    }
    players {
        officialId
        profileUrl
        name
        firstName
        lastName
        jerseyNum
        position
        isCaptain
        rosterStatus
        slug
        expFromYear
        accolades {
          awardName
          years
        }
        currentTeam{
          officialId
          jerseyNum
          position
          fullName
          injuryStatus
          conference
        }
      stats(segment: event) {
        points
        faceoffPct
        shotPct
        twoPointShotPct
        twoPointShotsOnGoalPct
        savePct
        shotsOnGoalPct
        onePointGoals
        scoresAgainst
        saa
        gamesPlayed
        goals
        twoPointGoals
        assists
        groundBalls
        turnovers
        causedTurnovers
        faceoffsWon
        faceoffsLost
        faceoffs
        shots
        twoPointShots
        twoPointShotsOnGoal
        goalsAgainst
        twoPointGoalsAgainst
        numPenalties
        pim
        pimValue
        saves
        powerPlayGoals
        powerPlayShots
        shortHandedGoals
        shortHandedShots
        shortHandedGoalsAgainst
        powerPlayGoalsAgainst
        shotsOnGoal
        tof
        goalieWins
        goalieLosses
        goalieTies
        GAA
        twoPtGaa
        plusMinus
        foRecord
      }
    }
    }
`
